import createReducer from '../lib/createReducer';
import * as types from '../actions/types';

export const vacanciesPL = createReducer(null, {
    [types.VACANCY_PL](state, action) {
        let newState = action.vacancies;
        return newState;
    }
});

export const vacancyBySlug = createReducer(null, {
    [types.VACANCY_BY_SLUG](state, action) {
        let newState = action.vacancy;
        return newState;
    }
});

export const vacancyPost = createReducer(null, {
    [types.VACANCY_POST](state, action) {
        let newState = action.vacancyPostState;
        return newState;
    }
});


// WEBPACK FOOTER //
// ./src/reducers/vacancy.js